import React from "react";
import bmc from "../images/bmc-button.png";

function Support() {
  return (
    <section className="bg-gray-100 py-8" id="support">
      <div className="container mx-auto px-2 pt-4 pb-12 text-gray-800">
        <h1 className="w-full my-2 text-5xl font-bold leading-tight text-center text-gray-800">Donate</h1>
        <div className="w-full mb-4">
          <div className="h-1 mx-auto gradient w-64 opacity-25 my-0 py-0 rounded-t"/>
        </div>
        <div className="text-center mb-6">
          <p>
            If you like this project and want to support it* feel free to buy me a Spritzer!
          </p>
          <small className="text-gray-600">* = server expenses, proxy expenses, maintenance, ...</small>
        </div>
        <div className="text-sm text-gray-600 text-center mx-auto">
          <a href="https://www.buymeacoffee.com/nehalist" target="_blank" rel="noreferrer">
            <img src={bmc} alt="Buy me a Spritzer" className="mx-auto" title="Why is there no white wine emoji?!"/>
          </a>
          <div className="mt-2">
            <a href="https://en.wikipedia.org/wiki/Spritzer" className="hover:underline text-sm" target="_blank" rel="noreferrer">What is a Spritzer?</a>
          </div>
        </div>
        <div className="container mx-auto text-center mt-5 border-t pt-5">
          <div className="mb-3 font-medium">Alternative ways:</div>
          <div className="grid sm:grid-cols-1 lg:grid-cols-1 gap-3">
            <div className="text-center mb-4">
              <h4 className="mb-2">BTC</h4>
              <code className="border p-2 border-r bg-white text-sm">14V54NVzqSgjKbYXt8orjbhUN1zPKUuyqx</code>
            </div>
            <div className="text-center mb-4">
              <h4 className="mb-2">ETH</h4>
              <code className="border p-2 border-r bg-white text-sm">0xf31a15f9a80016f3c591ff385be4c262e539f576</code>
            </div>
            <div className="mb-4">
              <h4 className="mb-2">Doge 🚀</h4>
              <code className="border p-2 border-r bg-white text-sm">DUM8Y6q45P9pKVdJ3A7EwVtqm8fbw3oc1A</code>
            </div>
            <div className="mb-4">
              <h4 className="mb-2">LTC</h4>
              <code className="border p-2 border-r bg-white text-sm">LXEAWvUJ8zEG7vwrfZ1DkHdBzvMNnPzko4</code>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Support;
